/**
 * Siatka wiersza sekcji (etykieta / wartość / kwota / akcja), wspólna dla
 * `SectionColumnHeader` i `BillSection`. Kolumna kwoty stoi na każdym ekranie
 * — układ bez niej kosztował parametr ciągnięty przez pięć komponentów.
 *
 * Cztery kolumny potrzebują 474 px plus wcięcia, więc pod tym progiem wiersz
 * składa się na dwie: etykieta nad wartością po lewej, kwota nad akcją po
 * prawej (rozmieszczenie robią same komórki przez `@max-[640px]:col-start-*`).
 *
 * Próg mierzy **kontener**, nie okno: sekcja siedzi w kolumnie treści, która
 * obok panelu bocznego bywa wąska także na szerokim ekranie. Zapytanie o okno
 * tego nie widzi — przy 1132 px okna kolumna wartości schodziła do 10 px i
 * tekst szedł pionowo, mimo że `sm:` dawno było spełnione.
 *
 * 640 px to 414 px kolumn stałych, 60 px odstępów, 38 px wcięć wiersza i
 * ~128 px, żeby kolumna wartości była czytelna. Karta sekcji ma o 2 px węższy
 * kontener, ale i o 2 px węższe wcięcia, więc jeden próg trafia w oba miejsca.
 */
export const billGridClass =
  'grid grid-cols-[1fr_auto] gap-x-4 @min-[640px]:grid-cols-[186px_1fr_132px_96px] @min-[640px]:gap-x-5';
